"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LinkBaseStyles = exports.linkVariants = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variant = _interopRequireDefault(require("@styled-system/variant"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var linkVariants = function linkVariants(props) {
  return (0, _variant["default"])({
    variants: {
      body: {
        '--color': props.theme.colors.magic.base,
        '--hover-color': props.theme.colors.magic.base,
        '--underline': 'none',
        '--hover-underline': 'underline'
      },
      nav: {
        '--color': props.theme.colors.slate.base,
        '--active-color': props.theme.colors.magic.base,
        '--hover-color': props.theme.colors.magic.base,
        '--underline': 'none',
        '--hover-underline': 'none'
      },
      legal: {
        '--color': props.theme.colors.slate.lightest,
        '--hover-color': props.theme.colors.magic.base,
        '--underline': 'underline',
        '--hover-underline': 'underline'
      },
      white: {
        '--color': props.theme.colors.white,
        '--hover-color': props.theme.colors.magic.base,
        '--underline': 'underline',
        '--hover-underline': 'underline'
      }
    }
  });
};

exports.linkVariants = linkVariants;
var LinkBaseStyles = (0, _styledComponents.css)(["color:", ";font-family:\"Space Grotesk\",sans-serif;font-weight:var(--font-weight);letter-spacing:var(--letter-spacing);display:inline;text-decoration:var(--underline);--font-weight:500;--letter-spacing:-0.4px;&:hover{color:var(--hover-color);text-decoration:var(--hover-underline);}> .button-icon-wrapper{margin-left:0.625rem;svg{display:flex;}}", ""], function (props) {
  return props.isActive ? "var(--active-color)" : "var(--color)";
}, linkVariants);
/**
 * @property {{ 'body' | 'nav' | 'legal' }} variant
 */

exports.LinkBaseStyles = LinkBaseStyles;
var LinkBaseComponent = (0, _styledComponents["default"])('a').attrs(function (props) {
  return {
    className: "gf-styled__link__".concat(props.variant)
  };
}).withConfig({
  displayName: "link-base__LinkBaseComponent",
  componentId: "sc-19tnw4x-0"
})(["", ""], LinkBaseStyles);
LinkBaseComponent.propTypes = {
  isActive: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['body', 'nav', 'legal', 'white'])
};
LinkBaseComponent.defaultProps = {
  isActive: false,
  variant: 'nav'
};
var _default = LinkBaseComponent;
exports["default"] = _default;